export const GetParametersFromHash = () => {
  if ( window.location.hash && Object.keys(window.location.hash).length > 0)
  {
    var hashpath = window.location.hash.substr(1);
    var queryparams = hashpath.split('?');
    if (queryparams.length < 2)
      return null;
    var buffer = [];
    var dict = {};
    var currentkey = [];
    var currentvalue = [];
    for(var i = 0; i < queryparams[1].length; i++)
    {
      if (queryparams[1][i] === "&" || i === queryparams[1].length-1)
      {
        if (i === queryparams[1].length -1)
          buffer.push(queryparams[1][i])
        if (buffer.length > 0)
          currentvalue = buffer.reduce((a, c) => a + c);
        else
          currentvalue = null;
        dict[currentkey] = currentvalue;
        currentvalue = [];
        currentkey = [];
        buffer = [];
      }
      else if (queryparams[1][i] === "=")
      {
        currentkey = buffer.reduce((a, c) => a + c);
        buffer = [];  
      }
      else 
        buffer.push(queryparams[1][i]);
    }
    if (dict)
      return dict;
    else return null;
  }
}